// extracted by mini-css-extract-plugin
export default {"slider_item":"styles_slider_item__De97l","banner_btn":"styles_banner_btn__cxcLA","slider_item_text":"styles_slider_item_text__hj4RI"};